import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import InitLayout from './Init'
import MainV2Layout from "./MainV2";
// import {useAuth0} from "../contexts/auth0-context";
import { useAuth0 } from '@auth0/auth0-react'
import { useData } from '../contexts/data-context'
import { APPS_PRODUCT_MAP } from '../services/utils'
import zafClient from '../services/zendesk'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: InitLayout,
  init: InitLayout,
}

const AppLayouts = {
  redact: MainV2Layout,
}

const mapStateToProps = ({ settings }) => ({ settings })
let previousPath = ''

const Layout = ({ children, location: { pathname, search }, isFullWidth }) => {
  const { isLoading } = useAuth0()
  const {
    isApiLoading,
    isIframeLogin,
    connectors,
    init_status,
    product,
    active_products,
  } = useData()

  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  // setTimeout(() => {
  //   NProgress.done()
  //   previousPath = currentPath
  // }, 300)

  const isSection = section => {
    const re = new RegExp('^/' + section + '(?=/|$)', 'i')
    return re.test(pathname)
  }
  // Layout Rendering
  const getLayout = () => {
    if (isSection('public')) {
      return 'public'
    }
    if (isSection('auth')) {
      return 'auth'
    }
    if (isSection('init')) {
      return 'init'
    }
    return 'main'
  }

  const needsToConnect = () => {
    const connected = connectors && !connectors.some(c => c.authenticated)
    return pathname !== '/init/connect' && connected
  }

  const needsToProcess = () => {
    return (
      pathname !== '/init/connect' &&
      pathname !== '/init/processing' &&
      init_status === 'processing'
    )
  }

  const isReady = () => {
    return (
      (pathname === '/init/processing' || pathname === '/init/expired') && init_status === 'ready'
    )
  }

  const hasExpired = () => {
    return (
      product !== 'easydoc' &&
      product !== 'macroexport' &&
      product !== 'hcmanager' &&
      product !== 'redact' &&
      product !== 'exportPdfs' &&
      product !== 'mcpserver' &&
      product !== 'lookup' &&
      product !== 'triggers_gpt' &&
      pathname !== '/invite-users' &&
      pathname !== '/init/expired' &&
      pathname !== '/payment' &&
      init_status === 'expired'
    )
  }

  const layout = getLayout()
  const requiresLogin = layout === 'init' || layout === 'main'
  const isUserLoading = isLoading === true || isApiLoading === true
  const pathToProduct = {
    '/auth/easydoc': 'easydoc',
    '/auth/exportPdfs': 'exportPdfs',
    '/auth/mcpserver': 'mcpserver',
    '/auth/macroexport': 'macroexport',
    '/auth/mergedup': 'mergedup',
    '/auth/cowriter': 'cowriter',
    '/auth/removecc': 'removecc',
    '/auth/attachments': 'attachments',
    '/auth/redact': 'redact',
    '/auth/triggers_gpt': 'triggers_gpt',
    '/auth/lookup': 'lookup',
    '/auth/document_parser': 'document_parser',
    '/auth/macrosearch': 'macrosearch',
    '/auth/resolveloop': 'resolveloop',
  }
  const selectedProduct = product || pathToProduct[pathname]
  const Container = (layout === 'main') ? AppLayouts[selectedProduct] || Layouts[layout] : Layouts[layout];

  const titleTemplate = {
    answersearch: 'Answer Search by Swifteq | %s',
    macrosearch: 'Macro Search by Swifteq | %s',
    translate: 'Translate Conversations by Swifteq | %s',
    cowriter: 'Agent Co-writer by Swifteq | %s',
    easydoc: 'Help Center Export for Zendesk Guide | %s',
    macroexport: 'Macros Export for Zendesk Support | %s',
    exportPdfs: 'Articles PDF Export for Zendesk | %s',
    mcpserver: 'Zendesk MCP Server | %s',
    mergedup: 'Merge Duplicates for Zendesk Support | %s',
    removecc: 'Remove CC from Zendesk Tickets | %s',
    attachments: 'Attachment Workflows for Zendesk | %s',
    redact: 'Auto Remove Attachments for Zendesk | %s',
    lookup: 'Ticket Parser Autofill for Zendesk | %s',
    triggers_gpt: 'Triggers+ChatGPT for Zendesk | %s',
    document_parser: 'Document Parser OCR by Swifteq | %s',
    resolveloop: 'ResolveLoop by Swifteq | %s',
  }

  const BootstrappedLayout = () => {
    if (pathname === '/' && window.ZAFClient && window['_zafClient'] === undefined) {
      const zafClient = window.ZAFClient.init()
      if (zafClient) {
        Promise.all([zafClient.metadata(), zafClient.context(), zafClient.get('currentUser')])
          .then(([metadata, context, userInfo]) => {
            const user = userInfo?.currentUser
            const app_title = ((metadata || {}).settings || {}).title
            localStorage.setItem('zendesk_subdomain', context?.account?.subdomain)
            localStorage.setItem('app_title', app_title)
            if (user && window.analytics && window.analytics.identify) {
              window.analytics.identify(user.id, {
                email: user.email,
                name: user.name,
                zendesk_role: user.role,
                subdomain: context?.account?.subdomain,
                product: APPS_PRODUCT_MAP[app_title],
              })
            }
            // if (user && window.rdt) {
            //   window.rdt('init','a2_do4vlmwyjx5l', {"optOut":false,"useDecimalCurrencyValues":true,"email":user.email,"externalId": user.id});
            // }
          })
          .catch(err => console.error(err))
      }
      window['_zafClient'] = zafClient
    }
    // show loader when user in check authorization process, not authorized yet and not on login pages
    if (requiresLogin && !isIframeLogin && (!init_status || isUserLoading)) {
      return null
    }

    if (isIframeLogin) {
      return <Redirect to="/auth/login_iframe" />
    }
    if (hasExpired()) {
      return <Redirect to="/init/expired" />
    }
    if (
      init_status !== 'expired' &&
      (active_products || []).indexOf(product) >= 0 &&
      product !== 'translate' && product !== 'cowriter' && product !== 'admin' &&
      needsToConnect()
    ) {
      return <Redirect to="/init/connect" />
    }
    if (init_status !== 'expired' && needsToProcess()) {
      return <Redirect to="/init/processing" />
    }
    if (init_status !== 'expired' && isReady()) {
      return <Redirect to="/" />
    }
    NProgress.done()
    previousPath = currentPath

    return <Container product={product}>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet
        titleTemplate={titleTemplate[selectedProduct]}
        title={titleTemplate[selectedProduct]}
      />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
